export default __webpack_public_path__ + "static/media/ganho.d505a99d.svg";